module.exports = __webpack_public_path__ + "assets/img/tag-reservation-94183e4f.png";